<template>
  <scroll-bar>
    <div class="sidebar-title" v-show="!isCollapse">
      <div class="titleLogo">秒付代理后台</div>
    </div>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import ScrollBar from "@/components/ScrollBar";

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters(["sidebar"]),
    routes() {
      // const agency_type = this.$store.state.user.userinfo.agency_type;
      // // 总代才显示
      // if (agency_type == 2) {
      //   return this.$router.options.routes.map(item => {
      //     if (item.name == "useroperation") {
      //       item.hidden = false;
      //     }
      //     return item;
      //   });
      // }

      return this.$router.options.routes;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>

<style>
.sidebar-title {
  height: 60px;
  line-height: 50px;
  color: #fff;
  font-size: 24px;
  text-align: center;
}
</style>
